import { Component, Input } from '@angular/core';
import { ReportFilterLookup, ReportFilterLookupsService } from '../report-filter-lookups.service';

/** The inline note beside a Reports filter whose list could not be loaded, with a link that loads it again. */
@Component({
  selector: 'app-report-lookup-note',
  standalone: true,
  template: `
    @if (lookups.failed.has(lookup)) {
      <span class="field__error tw:block" [attr.data-test]="'lookup-failed-' + lookup">Couldn't load {{ label }}.
        <a href="" (click)="$event.preventDefault(); lookups.retry(lookup)" [attr.data-test]="'lookup-retry-' + lookup">Retry</a>
      </span>
    }
  `
})
export class ReportLookupNoteComponent {
  @Input({ required: true }) lookup: ReportFilterLookup;
  /** The list's name as the note reads, such as "tutors". */
  @Input({ required: true }) label: string;

  constructor(public lookups: ReportFilterLookupsService) { }
}
